<template>
  <div class="community view-container" ref="community">
    <div class="community_btn">
      <div
        class="community_con"
        v-show="showBtn"
        :class="[showBtn?'animated bounceInUp':'animated bounceInDown']"
      >
        <div class="tiwen" @click="loginTo('/community/posting')">
          <img src="@static/images/app4_7/tiwen.png" alt />
        </div>
        <div class="wenda" @click="loginTo('/community/myZone')">
          <img src="@static/images/app4_7/wenda.png" alt />
        </div>
        <div class="guanbi" @click="showBtn=false">
          <img src="@static/images/app4_7/guanbi.png" alt />
        </div>
      </div>
      <div class="bianji" @click="showBtn=true" v-show="!showBtn">
        <img src="@static/images/app4_7/bianji.png" alt />
      </div>
    </div>
    <mescroll-vue ref="mescroll" :up="mescrollUp" :down="mescrollDown" @init="mescrollInit">
      <div class="content">
        <!--个人信息-->
        <div class="dlList">
          <!-- <dt>
              <span @click="loginTo('/community/myZone')">
                <img :src="user.headimgurl?user.headimgurl:'@static/images/default_auther.png'" alt="" class="myPhoto"/>
              </span>
              <p class="dlList-username" v-html="$options.filters.emoji(user.nickname || '未登录')"></p>
              <p class="lz-fs-32 sayContent dlList-say">资深保险规划师为您解惑</p>
              <a class="dlList-question" @click="loginTo('/community/posting')">我要提问</a>
          </dt>-->
          <img class="dlList_img" src="@static/images/app4_7/banner.png" alt />
        </div>
        <!-- 帖子分类 -->
        <div class="lz-tab" ref="navUl">
          <div class="swiper-wrapper">
            <div
              v-for="(value,i) in topList"
              class="swiper-slide"
              :class="value.code==postType?'active':''"
              @click="tabs(value.code)"
            >
              <span>{{value.text}}</span>
            </div>
          </div>
          <div class="button-prev">
            <i class="iconfont icon-jiantouzuo"></i>
          </div>
          <!--左箭头-->
          <div class="button-next">
            <i class="iconfont icon-gengduo"></i>
          </div>
          <!--右箭头-->
        </div>
        <app-list :mainData="mainList"></app-list>
      </div>
      <div id="emptyDom"></div>
    </mescroll-vue>
    <!-- <app-loading :loaded="loaded"></app-loading> -->
  </div>
</template>
 
<script>
// import loading from "@/components/commons/loading";
import list from "@/components/community/list";
import Swiper from "@static/js/swiper-4.3.3.min";
import "@static/css/swiper-4.3.3.min.css";
import animated from "@static/css/animate.min.css";
import mscll from "@/api/mescrolls.js"; //工具
import MescrollVue from "mescroll.js/mescroll.vue";

export default {
  data: () => ({
    showBtn: false,
    navNumber: 3, //底部导航
    topList: [], //顶部列表
    mainList: [], //主列表数据
    // loaded: false,
    postType: 0, //类型
    pageNum: 1, //页数
    pageSize: 20, //每页个数
    scroll: undefined, //滚动对象
    isloading: false, //是否允许滚动
    navUlHeight: 0, //tab栏高度
    user: {
      headimgurl: "",
      nickname: ""
    }
  }),
  components: {
    // "app-loading": loading,
    "app-list": list,
    "mescroll-vue": MescrollVue
  },
  created() {
    var self = this;
    // this.shareMsg()
    this.getTopList();
    this.user = {
      headimgurl: this.$config.user ? this.$config.user.headimgurl : "",
      nickname: this.$config.user ? this.$config.user.nickname : ""
    };
  },
  beforeDestroy() {
    this.mescroll.setBounce(true);
  },
  methods: {
    //我的问答
    loginTo(href) {
      if (!this.$units.isLogin(this)) {
        return;
      }
      location.href = href;
    },
    /** mescroll 初始化*/
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
      let pageHeight = this.$parent.$refs.pageHeight.clientHeight,
        height;
      this.$refs.community.style.height = pageHeight - 46 - 45 + "px";
    },
    getDetails(id) {
      return "./community/myZoneDetails.html?id=" + id;
    },
    tabs(code) {
      //顶部导航事件
      if (this.postType == code) return;
      this.mainList = [];
      this.postType = code;
      this.pageNum = 1;
      this.mescroll.resetUpScroll();
    },
    getTopList() {
      //初始化mescroll+顶部tab栏内容获取
      var self = this;
      var tab = this.$route.params.tab;
      if (tab) self.postType = tab;
      mscll.init(
        this,
        { use: false },
        {
          callback: self.getMainList,
          page: {
            num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
            size: self.pageSize //每页数据条数,默认10
          },
          empty: {
            warpId: "emptyDom",
            tip: "暂无相关数据~",
            icon: require("@static/images/empty.png")
          }
        }
      );
      this.$nextTick(() => {
        //获取导航栏到顶部的高度，用于切换时回到此为止
        this.navUlHeight = this.$refs.navUl.offsetTop;
      });
      //获取顶部推荐栏数据
      this.$http({
        url: "/app/common/api/dic?type=sqPostType",
        type: "get"
      })
        .then(r => {
          this.topList = r.data;
          setTimeout(function() {
            var mySwiper = new Swiper(".lz-tab", {
              slidesPerView: "auto",
              spaceBetween: 5,
              normalizeSlideIndex: false,
              iOSEdgeSwipeDetection: false,
              navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev"
              },
              slidesPerGroup: 2,
              on: {
                init: function() {
                  if (tab) {
                    for (var k in r.data) {
                      if (r.data[k].code == tab) {
                        this.slideTo(k, 1000, false);
                        break;
                      }
                    }
                  }
                }
              }
            });
          }, 100);
        })
        .catch(err => {});
    },
    getMainList(page, mescroll) {
      var self = this;
      //获取社区列表数据
      this.$http({
        url: "/app/sq/mainpost/api/type",
        type: "get",
        data: {
          postType: Number(self.postType),
          pageSize: self.pageSize,
          pageNum: page ? page.num : self.pageNum
        }
      })
        .then(r => {
          console.log(r);
          self.loaded = true;
          if (self.pageNum == 1 && page.num == 1) {
            //tab点击事件加载
            self.mainList = r.data;
            let _scrollTop = self.$refs.mescroll.$el.scrollTop;
            if (_scrollTop > self.$refs.navUl.offsetTop) {
              self.mescroll.setScrollTop(self.navUlHeight);
            }
          } else {
            //普通滑动加载
            self.mainList = self.mainList.concat(r.data);
          }
          self.mescroll.endSuccess(r.data.length);
        })
        .catch(err => {
          if (self.mescroll) self.mescroll.endSuccess();
          self.loaded = true;
        });
    }
  },
  mounted() {},
  activated() {
    // this.shareMsg();
    var userInfo = this.$config.user || {};
    if (this.user.nickname == userInfo.nickname) return;
    this.user = {
      headimgurl: userInfo.headimgurl,
      nickname: userInfo.nickname
    };
  },
  beforeRouteLeave(to, from, next) {
    this.mescroll.setBounce(true);
    next();
  }
};
</script>

<style lang="scss">
@import "~@/sass/community/community";
</style>
